module.exports = __webpack_public_path__ + "static/cityscape-1280-fc0edec9b6cd86b92cad4eaaf52ed11f.png";